module.exports = __webpack_public_path__ + "static/ufo_img2-b8f65736b61ebd6c77b6c2e8268d70c4.png";